package org.zest.insan_360_website.pages.user

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Iframe
import org.zest.insan_360_website.components.layouts.PageContentContainer
import org.zest.insan_360_website.components.layouts.containerShadowStyle
import org.zest.insan_360_website.components.layouts.userPageBorderStrongColor
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.components.widgets.RoleGate
import org.zest.insan_360_website.model.UserRole

@Page("/user/coach-assistant")
@Layout(".components.layouts.UserDashboardLayout")
@Composable
fun CoachAssistantPage(ctx: PageContext) {
    RoleGate(UserRole.ADMIN, ctx = ctx) {
        PageContentContainer(
            Modifier
                .padding(0.px)
                .overflow(Overflow.Clip)
                .border {
                    width(2.px)
                    color(userPageBorderStrongColor)
                }
                .then(containerShadowStyle.toModifier())
        ) {
            Iframe(
                Modifier
                    .fillMaxSize()
                    .toAttrs {
                        attr("src", "https://app.edcafe.ai/chatbots/6a4d86708d94bf6b2b8fd2f5")
                        attr("title", "Pembantu Perunding Tingkah Laku INSAN360")
                        attr("sandbox", "allow-scripts allow-forms allow-popups allow-same-origin")
                        attr("referrerpolicy", "strict-origin-when-cross-origin")
                        attr("allow","clipboard-write microphone")
                        attr("style", "border: none; width: 100%; height: 100%; min-height: 600px")
                    }
            )
        }
    }
}